//NEW: UI_REVAMP
import {
	Button,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Text,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useBettingScreen } from '../../hooks/useStore';

const LogoutModal = ({ isOpen, onClose, jsParseLocal }) => {
	const navigate = useNavigate();

	const removeAll = useBettingScreen((state) => state.removeAll);
	const removeAllStl = useBettingScreen((state) => state.removeAllStl);

	const handleLogout = () => {
		onClose();

		navigate('/');
		removeAll();
		removeAllStl();

		if (window.ReactNativeWebView) {
			localStorage.clear();
		}

		sessionStorage.clear();

		if (window.smartsupp && jsParseLocal) {
			if (jsParseLocal.opened === 'true') {
				delete jsParseLocal?.opened;
				localStorage.setItem(
					`ssupp_${jsParseLocal.data?.data?.string}`,
					JSON.stringify(jsParseLocal),
				);
			}
		}
	};

	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered size='sm'>
			<ModalOverlay />
			<ModalContent marginX={3}>
				<ModalCloseButton />
				<ModalHeader />
				<ModalBody>
					<Flex>
						<Text fontSize='18px' margin='20px'>
							Sure to logout?
						</Text>
					</Flex>

					<Flex justifyContent='flex-end' width='100%' marginY='20px'>
						<Button marginRight={2} bgColor='blue.700' onClick={handleLogout}>
							<Text color='white'>OK</Text>
						</Button>

						<Button onClick={onClose}>
							<Text>Cancel</Text>
						</Button>
					</Flex>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};

export default LogoutModal;
